import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import { trackWhatsApp, buildWhatsAppText } from "src/utils/tracking";
import button from "../../../assets/img/landingPageThree/sectionSeven/button.webp";

function SectionSeven() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div className={`sectionSeven-bg ${isVisible ? "visible" : ""}`}>
        <div className="sectionSeven">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp3_cta_title")} <br /> <span>{t("lp3_cta_subtitle")}</span>
          </h1>
          <div className={`line ${isVisible ? "visible" : ""}`}></div>
          <a
            className={`${isVisible ? "visible" : ""}`}
            href={"https://wa.me/5547992246105?text=" + buildWhatsAppText("Olá, estou entrando em contato pelo site da GH Solucionador Logístico. Poderia me ajudar, por favor?")}
            rel="noreferrer"
            reloadDocument
            onClick={() => trackWhatsApp("lp_armazem_sec7")}
          >
            <img src={button} alt="" />
            <p>{t("lp3_cta_button")}</p>
          </a>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default SectionSeven;
